<div class="justify-content-center" style="padding-top: 30px;">
  <h4 class="text-center" style="font-weight: bold">Complete your KYC</h4>
</div>
<div class="container">
  <div class="row" style="padding-top: 30px;">
    <div class="col-md-4 d-flex justify-content-center"> 
      Business Details
    </div>
    <div class="col-md-4 d-flex justify-content-center">
      Business Documents
    </div>
    <div class="col-md-4 d-flex justify-content-center"  style="color:blue; font-weight: bold;">
      Website Details
    </div>
  </div>
</div>
<div class="row">
  <div class="offset-xl-1 col-xl-5 col-lg-6 col-md-12">
    <!-- Card -->
    <div class="register-card" style="z-index: 1;">
      <!-- Card body -->
      <div class="container">
        <div class="row">
          <h5  style="padding-top: 30px;font-weight:bold;padding-left: 30px;">Enter your website details<span><svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle r="6.5" transform="matrix(1 0 0 -1 6.5 7)" fill="#D6D6D6"/>
            <path d="M7.42606 4.95466C7.98309 4.95466 8.43464 4.50311 8.43464 3.94608C8.43464 3.38906 7.98309 2.9375 7.42606 2.9375C6.86904 2.9375 6.41748 3.38906 6.41748 3.94608C6.41748 4.50311 6.86904 4.95466 7.42606 4.95466Z" fill="white"/>
            <path d="M8.45726 9.04667C8.4294 9.02793 8.39807 9.01494 8.36512 9.00847C8.33217 9.00199 8.29826 9.00217 8.26538 9.00898C8.23249 9.01579 8.2013 9.0291 8.17363 9.04813C8.14597 9.06716 8.12238 9.09152 8.10425 9.11979C7.8605 9.48078 7.5619 9.8015 7.21922 10.0704C7.13602 10.1334 6.82588 10.373 6.69476 10.3225C6.60399 10.2948 6.65694 10.1158 6.67459 10.0401L6.80823 9.64426C6.8637 9.48288 7.82942 6.61851 7.93532 6.29072C8.09165 5.81165 8.02357 5.34013 7.31 5.4536C7.11584 5.47377 5.14659 5.72844 5.11129 5.73096C5.07818 5.73311 5.04581 5.74176 5.01604 5.75642C4.98628 5.77108 4.95969 5.79146 4.93779 5.8164C4.9159 5.84133 4.89914 5.87034 4.88845 5.90175C4.87777 5.93317 4.87338 5.96638 4.87553 5.99949C4.87768 6.03261 4.88634 6.06497 4.901 6.09474C4.91566 6.12451 4.93604 6.15109 4.96097 6.17299C4.98591 6.19488 5.01491 6.21165 5.04633 6.22233C5.07774 6.23301 5.11095 6.2374 5.14407 6.23525C5.14407 6.23525 5.9005 6.13691 5.98371 6.12935C6.02633 6.12519 6.06925 6.13345 6.10728 6.15313C6.14531 6.17282 6.17683 6.20309 6.19804 6.24029C6.24372 6.38153 6.23746 6.53443 6.18038 6.67146C6.11483 6.92361 5.07851 9.84345 5.04573 10.0124C5.01057 10.1538 5.02033 10.3026 5.07366 10.4381C5.12698 10.5737 5.22121 10.6893 5.34326 10.7688C5.57234 10.9215 5.84509 10.995 6.11987 10.9781C6.38704 10.9748 6.65125 10.9218 6.899 10.8218C7.52684 10.5696 8.18242 9.89892 8.52786 9.37194C8.55761 9.3184 8.56684 9.25586 8.55385 9.196C8.54086 9.13614 8.50652 9.08306 8.45726 9.04667Z" fill="white"/>
            </svg></span>
            </h5>
        </div>
        <form [formGroup]="registerForm" style="padding-top: 15px;padding-left: 20px;">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                  <label style="font-weight:bold;">Webiste URL</label>
                  <input type="text" formControlName="webisteUrl" class="form-control" 
                  placeholder="Ex: www.swiftchat.com" 
                   [ngClass]="{ 'is-invalid': submitted && f.webisteUrl.errors }" />
                  <div *ngIf="submitted && f.webisteUrl.errors" class="invalid-feedback">
                      <div *ngIf="f.webisteUrl.errors.required">Webiste URL is required</div>
                  </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                  <label style="font-weight:bold;">Enter email id for verification of domain name</label>
                  <div class="input-group">
                    <input type="text" class="form-control"
                    formControlName="emailId"
                    placeholder="Email ID"
                    [ngClass]="{ 'is-invalid': submitted && f.emailId.errors }" aria-describedby="button-addon2">
                    <span>
                      <input type="submit" class="button" value="Verify" />
                       </span>
                  </div>
                  <!-- <input type="text" formControlName="emailId" class="form-control" 
                  placeholder="Email ID"
                  [ngClass]="{ 'is-invalid': submitted && f.emailId.errors }"/> -->
                  <div *ngIf="submitted && f.emailId.errors" class="invalid-feedback">
                    <div *ngIf="f.emailId.errors.required">Email ID is required</div>
                    <div *ngIf="f.emailId.errors.email">Email must be a valid email address</div>
                </div>
                </div>
               
            </div>
            <div class="col-6">
              
            </div>
            <div class="col-6" style="padding-top: 20px;">
              <label class="p-3 rounded" style="background-color: bisque;">Click on the link sent to this email ID for verification</label>
            </div>
            </div>
          <div class="text-center">
              <button class="btn add btn-outline-primary" (click)="onReset()">Skip to Dashoboard</button>
              <button class="btn add btn-primary" (click)="onSubmit()">Submit</button>
          </div>
          
      </form>
        <!-- The Modal -->
  
      </div>
     
    </div>
  </div>

</div>